window.chartPkvPpv = {
	data: {
		beitraege_kv: [],
		beitraege_pv: [],
		beitraege_zusatz: [],
		arbeitgeberzuschuesse: [],
		startdatum: 0,
		enddatum: 0,
	},

	showLoading() {
		if (this.chart) this.chart.showLoading()
	},

	hideLoading() {
		if (this.chart) this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.stockChart("chart_pkv_ppv", {
			chart: {
				events: {
					selection: function (event) {
						return zoomIn(chartPkvPpv, event)
					},
				},
			},

			xAxis: {
				ordinal: false,
				min: this.data.startdatum,
				max: this.data.enddatum,
				events: {
					afterSetExtremes: function (event) {
						const chart = event.target.chart,
							min = event.min,
							max = event.max

						updateDataGrouping(chart, min, max)
					},
				},
			},

			legend: {
				enabled: true,
			},

			series: this.seriesLiqui(),
		})

		// Wenn der Chart Zeitraum kleiner ist als die Monatsgrenze das DataGrouping deaktivieren
		updateDataGrouping(this.chart, this.data.startdatum, this.data.enddatum)
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.seriesLiqui()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		// xAchse: Min und Max aktualisieren
		this.updateXAxisMinMax()

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	updateXAxisMinMax() {
		const seriesMaxValues = this.chart.series.map((serie) => (Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined)),
			xAxisMaxValue = Math.max(this.data.enddatum, ...seriesMaxValues.filter((element) => element !== undefined))
		this.chart.xAxis[0].update({ min: this.data.startdatum, max: xAxisMaxValue })
	},

	seriesLiqui() {
		return [
			{
				name: "Krankenversicherung",
				id: "beitrag_kv",
				legendName: "Krankenversicherung",
				type: "column",
				color: farbeBeitrag1,
				index: 1,
				legendIndex: 0,
				data: this.data.beitraege_kv,
			},
			{
				name: "Pflegeversicherung",
				id: "beitrag_pv",
				legendName: "Pflegeversicherung",
				type: "column",
				color: farbeBeitrag2,
				index: 2,
				legendIndex: 1,
				data: this.data.beitraege_pv,
			},
			{
				name: "Temporäre Beiträge",
				id: "beitrag_zusatz",
				legendName: "Temporäre Beiträge",
				type: "column",
				color: farbeBeitrag3,
				index: 0,
				legendIndex: 2,
				data: this.data.beitraege_zusatz,
			},
			{
				name: "Arbeitgeberzuschuss",
				id: "arbeitgeberzuschuss",
				legendName: "Arbeitgeberzuschuss",
				type: "column",
				color: farbeZulagen,
				stack: "zuschuss",
				visible: false,
				legendIndex: 3,
				data: this.data.arbeitgeberzuschuesse,
			},
		]
	},
}
